import { Component, OnInit, Input, Inject, ElementRef, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GoogleService } from '../../../shared/Google.service';
import { Importdata } from '../../../shared/models/Importdata';
import { Shelf } from '../../../shared/models/shelf';
import { Constants } from '../../../shared/models/constants';
import { PouchdbService } from '../../../shared/pouchDb.service';
import { ShelfPouchDb } from '../../shelf.pouchdb.service';
import { Book } from '../../../shared/models/book';
import * as _ from 'lodash';
import { IS_ElectronService } from '../../../shared/IS_Electron.service';
@Component({
  selector: 'app-Googledetails',

  templateUrl: './Googledetails.component.html',
  styleUrls: ['./Googledetails.component.css']
})
export class GoogledetailsComponent implements OnInit, OnDestroy {


  @Input() data: any;

  GoogleDetals;
  selectedTab = 0;
  listOfElememts;
  myContentElements = []
  constructor(public dialog: MatDialog, private chRef: ChangeDetectorRef, public electronSerivce: IS_ElectronService, public mainpouchservice: PouchdbService, public pouchservice: ShelfPouchDb, public googleservice: GoogleService) { }
  GoogleFooterIcon = ["icon-Delete", "icon-Book-Export"];
  ShareList
  ngOnInit() {
    this.GoogleDetals = this.data.popupProps.curComp.selGoogleDetals;
    this.ShareList = this.googleservice.ShareList;
  }
  ngOnDestroy() {
    this.chRef.detach();
  }

  messagecloes() {
    let dialogRef = this.dialog.closeAll();
  }
  sharefileinfo(id) {
    this.newElePopup(id, this.data.popupProps.curComp);
    // this.chRef.detectChanges();
    this.data.popupProps.curComp.sharefile()
  }
  switchTabs(index, id) {
    if (index == 0) {
      this.data.popupProps.curComp.deletethefile(index, id)
      // this.chRef.detectChanges();
    }
    else {
      if (this.electronSerivce.IS_ELECTRON) {
        this.electronSerivce.downloadeImport(this.GoogleDetals.webContentLink, this.electronSerivce.USER_PATH + '/Export.pdf')
        this.importifle(this.electronSerivce.USER_PATH + '/Export.pdf');
      }

      // this.importifle()
    }
  }

  message() {
    let dialogRef = this.dialog.open(message, {
      width: '300px',
      //data: information,

    });
  }


  importifle(url) {

    this.googleservice.insertPermission(this.GoogleDetals.id)
    var bookObj = new Book();

    bookObj.author = Constants.USER;
    //bookObj.bookType = result.type == "book" ? bookCategoeyEnums.Ebook : bookCategoeyEnums.Album;
    //bookObj.templateId = this.GoogleDetals.id;
    bookObj.bookCategory = 3;
    bookObj.title = this.GoogleDetals.title;
    bookObj.owner = Constants.USER;
    bookObj.bId = Constants.getGUID();
    bookObj._id = Constants.USER + "." + Math.round(new Date().getTime() / 1000) + ".book";
    bookObj.coverPage = "https://lh3.google.com/u/0/d/" + this.GoogleDetals.id;
    bookObj.url = url;
    bookObj.description = "";
    bookObj.downloadUrl = this.GoogleDetals.downloadUrl;
    this.pouchservice.addimportfile(bookObj);
    this.data.popupProps.curComp.sharefile()
    this.message()
    setTimeout(() => {
      this.messagecloes()
    }, 2000);
  }
  newElePopup(value, datashare) {
    let information = { 'id': value, 'Data': datashare, }



    let dialogRef = this.dialog.open(sharefile, {
      height: '800px',
      width: '800px',
      data: information,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        //this.createNewElessonBook(result)
      }
    });

  }
}
@Component({
  selector: 'app-popup',
  templateUrl: './sharefile.html',
  styleUrls: ['./Googledetails.component.css']
})

export class sharefile implements OnInit {
  selectedTab = false
  searchContact = "";
  showedit = false;
  selectedTabread = false
  showError = false;
  newmailid = '';
  selectedThemeInd = undefined;
  bookNameErr = false;
  ebeBookTitle = '';
  selectedBookTypeInd: Number = 0;
  selectedTemplateViewInd = 0;
  bookTemplates;
  bookTemplateDetails;
  bookThemes;
  parentid
  url;
  imageDetails;
  conatctlist
  ShareList
  roles
  ContactList
  constructor(
    public dialogRef: MatDialogRef<sharefile>, private google: GoogleService, @Inject(MAT_DIALOG_DATA) public data: any, private chRef: ChangeDetectorRef) { }
  ngOnInit() {

    this.google.GetContactList(this)

  }

  getcontact(contact) {
    this.ShareList = contact.appPremissions.contacts
    this.ContactList = _.map(this.ShareList, 'user.name')
  }
  mydata = []
  contactlist
  selectContactToShare(contact, ind) {
    var r = _.findIndex(this.mydata, function (o) { return o.user.name == contact; });
    contact.user.isChecked = !contact.user.isChecked;
    if (contact.user.isChecked) {
      this.mydata.push(contact)
    }
    else {
      var r = _.findIndex(this.mydata, function (o) { return o.user.id == contact.user.id; });
      this.mydata.splice(r, 1)




    }
    this.contactlist = _.map(this.mydata, 'user.email')
  }
  onNoClick() {

    this.dialogRef.close(undefined);
    // this.chRef.detectChanges();
    //this.onYesClick('')
  }


  onYesClick(name) {

    try {
      if (this.selectedTab == true) {
        this.roles = 'writer'
      }
      else {
        this.roles = 'reader'
      }
      this.google.Sharefile(this.data.id, name, this.contactlist, this.roles)
    }
    catch (ex) { }
    this.dialogRef.close();
    // this.chRef.detectChanges();
    // this.data.Data.popupProps.curComp.Getfolderdtaledrive(this.data)
  }
  updatemailid(ev, name) {
    if (ev.which == 13) {
      this.onYesClick(name);
    }
  }

}

@Component({
  selector: 'app-popup',
  templateUrl: './message.html',
  styleUrls: ['./Googledetails.component.css']
})

export class message {

  showError = false;
  newmailid = '';
  selectedThemeInd = undefined;
  bookNameErr = false;
  ebeBookTitle = '';
  selectedBookTypeInd: Number = 0;
  selectedTemplateViewInd = 0;
  bookTemplates;
  bookTemplateDetails;
  bookThemes;
  parentid
  url;
  imageDetails;
  constructor(
    public dialogRef: MatDialogRef<message>, private google: GoogleService, @Inject(MAT_DIALOG_DATA) public data: any, private chRef: ChangeDetectorRef) { }

  onNoClick() {

    this.dialogRef.close(undefined);
    // this.chRef.detectChanges();
    //this.onYesClick('')
  }



  onYesClick(name) {

    try {
      //this.google.Sharefile(this.data, name)
    }
    catch (ex) { }
    this.dialogRef.close();
    // this.chRef.detectChanges();
    // this.data.Data.popupProps.curComp.Getfolderdtaledrive(this.data)
  }
  updatemailid(ev, name) {
    if (ev.which == 13) {
      this.onYesClick(name);
    }
  }

}






// WEBPACK FOOTER //
// ./src/app/shelf/popups/Googledetails/Googledetails.component.ts